import DefaultCompanyLogo from '@components/icons/DefaultCompany'

import { Chat, ChatType } from '../types'
import { ChatAvatarWrapper } from './index.styles'

const ChatAvatar = (props: { chat: Chat; isBgPrimary?: boolean; skipInitials?: boolean; width?: string; height?: string }) => {
  const {
    isBgPrimary,
    chat: { avatar, type, name = '', isIncoming },
    skipInitials,
    width = '36px',
    height = '36px',
  } = props

  if (avatar) {
    return (
      <ChatAvatarWrapper width={width} height={height}>
        <img style={{ width: 'inherit' }} src={avatar} alt="chat-avatar" />
      </ChatAvatarWrapper>
    )
  }

  if (type === ChatType.DIRECT || (type === ChatType.GROUP && isIncoming)) {
    if (skipInitials) {
      return null
    }

    return (
      <ChatAvatarWrapper width={width} height={height}>
        {name.split(' ')[0]?.charAt(0)}
        {name.split(' ')[1]?.charAt(0)}
      </ChatAvatarWrapper>
    )
  }

  return (
    <ChatAvatarWrapper width={width} height={height}>
      <DefaultCompanyLogo color={isBgPrimary ? 'secondary' : 'primary'} fontSize="inherit" />
    </ChatAvatarWrapper>
  )
}

export default ChatAvatar
